function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MontserratFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2417",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2417)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2417",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2417)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask2_621_2417",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "14",
        height: "11",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "13.5",
          height: "10.5",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_2417)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-1.50317 12.7499L1.46754 14.0528L13.5674 4.41657L15.1344 2.48042L11.9577 2.04496L7.02241 6.19747L3.05003 8.9953L-1.50317 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.0965 13.6627L0.416945 14.4188L14.5717 2.30053H12.4467L-1.0965 13.6627Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M15.0032 12.7499L12.0325 14.0528L-0.0673752 4.41657L-1.63436 2.48042L1.54239 2.04496L6.47765 6.19747L10.45 8.9953L15.0032 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.9019 13.405L13.3884 14.1611L7.36117 8.9726L5.57422 8.39291L-1.78515 2.48701H0.339895L7.69513 8.25273L9.64885 8.94784L14.9019 13.405Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "path-9-outside-1_621_2417",
          maskUnits: "userSpaceOnUse",
          x: "-1",
          y: "2",
          width: "16",
          height: "13",
          fill: "black",
          children: [/*#__PURE__*/_jsx("rect", {
            fill: "white",
            x: "-1",
            y: "2",
            width: "16",
            height: "13"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
          fill: "#F7FCFF",
          mask: "url(#path-9-outside-1_621_2417)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.6965 19.4975C17.7159 19.4975 17.0181 19.2706 16.5161 18.8624C16.0133 18.4535 15.6909 17.8497 15.4871 17.0645C15.283 16.2784 15.2004 15.3212 15.1697 14.2179C15.148 13.4421 15.1521 12.5996 15.1563 11.698C15.158 11.3569 15.1596 11.0074 15.1599 10.6499H22.3125C22.4405 12.8875 22.4945 15.0927 22.042 16.7465C21.8124 17.5856 21.4552 18.2714 20.9212 18.7474C20.3895 19.2213 19.6709 19.4975 18.6965 19.4975Z",
        fill: "#6DC2FF",
        stroke: "#F7FCFF",
        strokeWidth: "0.25"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask3_621_2417",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "15",
        y: "10",
        width: "8",
        height: "10",
        children: /*#__PURE__*/_jsx("path", {
          d: "M18.6965 19.4975C17.7159 19.4975 17.0181 19.2706 16.5161 18.8624C16.0133 18.4535 15.6909 17.8497 15.4871 17.0645C15.283 16.2784 15.2004 15.3212 15.1697 14.2179C15.148 13.4421 15.1521 12.5996 15.1563 11.698C15.158 11.3569 15.1596 11.0074 15.1599 10.6499H22.3125C22.4405 12.8875 22.4945 15.0927 22.042 16.7465C21.8124 17.5856 21.4552 18.2714 20.9212 18.7474C20.3895 19.2213 19.6709 19.4975 18.6965 19.4975Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.25"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask3_621_2417)",
        children: [/*#__PURE__*/_jsx("rect", {
          x: "14.9494",
          y: "10.5",
          width: "7.5525",
          height: "6.08351",
          fill: "#2EBED7"
        }), /*#__PURE__*/_jsx("rect", {
          x: "14.85",
          y: "16.5341",
          width: "7.95",
          height: "3.11595",
          fill: "#A95601"
        }), /*#__PURE__*/_jsx("path", {
          d: "M19.3093 13.1412C19.3093 13.1412 17.909 13.4641 18.0444 13.1412C18.1798 12.8183 18.5419 11.6539 18.5419 11.6539",
          stroke: "#FFC6B5",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.7305 13.3714C19.7305 13.3714 19.475 13.2123 19.475 12.9224C19.475 12.6326 18.852 12.5241 19.2913 12.0713C19.7305 11.6184 19.9201 11.8178 19.9201 12.0713C19.9201 12.3247 20.2731 12.9224 20.2731 12.9224L19.7305 13.3714Z",
          fill: "#FFC6B5"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.0238 10.7473H18.3281V11.4398H16.9369V12.1322H18.3281V18.1662H19.0238V12.1322H20.415V11.4398H19.0238V10.7473Z",
          fill: "#272727"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.5216 18.37C20.5216 18.37 20.2685 17.1793 20.2685 16.3642C20.2685 15.5492 19.8445 14.9663 19.9656 14.5352C20.0868 14.1042 20.3786 13.6276 20.2327 13.3326C20.0868 13.0376 20.3751 12.894 19.9656 13.0376C19.5562 13.1812 19.4461 12.894 19.0508 13.0376C18.6555 13.1812 18.6055 13.8594 18.6055 14.0529C18.6055 14.2464 18.7812 15.5507 18.7812 15.9575C18.7812 16.3642 18.6364 18.8654 19.0508 18.8654C19.4652 18.8654 19.9171 18.2145 20.0749 18.2145C20.2327 18.2145 20.5216 18.37 20.5216 18.37Z",
          fill: "#0C7C38"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.0224 15.1828C17.7698 15.1828 18.0021 15.7794 17.3593 16.041C16.7165 16.3026 16.5904 16.6709 16.7929 16.6709C16.9953 16.6709 18.5964 18.4998 18.5964 18.4998L18.989 17.8827V15.9341C18.989 15.9341 18.275 15.1828 18.0224 15.1828Z",
          stroke: "#FF9A06",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M19.9074 18.2453C19.9074 18.2453 20.2074 18.8891 19.9074 18.8891",
          stroke: "#979797",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M19.8109 13.3901C19.8109 13.3901 19.6791 14.1243 19.4282 14.278C19.1772 14.4317 18.1464 14.7292 18.1464 14.9833C18.1464 15.2374 18.0441 15.3282 18.0441 15.3282",
          stroke: "#FFC6B5",
          strokeWidth: "0.5"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3109 11.8745C19.3109 11.8745 19.5632 12.1793 19.7044 12.6816C19.8456 13.184 20.2548 13.3552 20.2548 13.12C20.2548 12.8849 20.5572 11.8745 20.2548 11.8745C19.9523 11.8745 19.3109 11.8745 19.3109 11.8745Z",
          fill: "#FF9A06"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Montserrat.js.map